module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./node_modules/symbol-observable/index.js
// module id = 108
// module chunks = 0